import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/reporter';

// TODO: These should be exported from for a source of truth our
// implementation's types can be "tested" against.

const template = hbs`
  <Banking::Activity::Bundle
    @isBundleExpanded={{this.isBundleExpanded}}
    @activity={{this.activity}}
    @onActivitySelect={{this.onActivitySelect}}
  />`;
const mapStateToProps = (state, ownArgs) => {
  const isBundleExpanded = state.expandedBundles.has(ownArgs?.activity?.id);
  return {
    isBundleExpanded,
    activity: ownArgs.activity,
    onActivitySelect: ownArgs.onActivitySelect
  };
};
const mapActionsToProps = () => ({});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);